var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPaperclipInVerticalPosition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.125 4.75V28.5C26.125 32.4354 22.9354 35.625 19 35.625C15.0646 35.625 11.875 32.4354 11.875 28.5V7.125C11.875 4.5018 14.0018 2.375 16.625 2.375C19.2482 2.375 21.375 4.5018 21.375 7.125V28.5C21.375 29.8122 20.311 30.875 19 30.875C17.6878 30.875 16.625 29.8122 16.625 28.5V9.5H14.25V28.5C14.25 31.1232 16.3768 33.25 19 33.25C21.6232 33.25 23.75 31.1232 23.75 28.5V7.125C23.75 3.18965 20.5604 0 16.625 0C12.6896 0 9.5 3.18965 9.5 7.125V29.6875C10.0854 34.3722 14.1562 38 19 38C23.8438 38 27.9146 34.3722 28.5 29.6875V4.75H26.125Z",
    fill: "#D7181D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperclipInVerticalPosition);
export default __webpack_public_path__ + "static/media/icon-paperclip-in-vertical-position.94d22eba0259cfe5a6500a980fd6705d.svg";
export { ForwardRef as ReactComponent };